interface MobileMenuTogglerProps {
  onClickHandler: () => void;
}

const MobileMenuToggler = ({ onClickHandler }: MobileMenuTogglerProps) => (
  <button
    type="button"
    className="w-10 space-y-2 rounded-md p-2 outline outline-1 outline-design-secondary-black dark:bg-design-black dark:outline dark:outline-2 dark:outline-design-black-accent"
    onClick={onClickHandler}
    aria-label="Mobile menu"
  >
    <div className="h-0.5 w-6 bg-design-black dark:bg-white" />
    <div className="h-0.5 w-6 bg-design-black dark:bg-white" />
    <div className="h-0.5 w-6 bg-design-black dark:bg-white" />
  </button>
);

export default MobileMenuToggler;
